import { render, staticRenderFns } from "./TableSendEdit.vue?vue&type=template&id=0d3eb5e1&scoped=true"
import script from "./TableSendEdit.vue?vue&type=script&lang=js"
export * from "./TableSendEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3eb5e1",
  null
  
)

export default component.exports